import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";

const FirstStep = ({ projectData, setProjectData, setProjectImage }) => {
  const [dropbtn, setDropbtn] = useState("India");
  return (
    <>
      <div
        id="wizard_Time"
        className="tab-pane"
        role="tabpanel"
        style={{ overflowY: "visible" }}
      >
        <h4 className="title">Project Details</h4>
        <div className="row sp15">
          <div className="col-12">
            <label className="form-label" style={{ marginBottom: 0 }}>
              Image
            </label>
            <div className="input-group">
              <input
                value={projectData.image}
                onChange={(e) => setProjectImage(e.target.files[0])}
                name="dzName"
                required=""
                type="file"
                className="form-control"
                placeholder="Project Image"
                style={{ padding: "15px 25px" }}
              />
            </div>
          </div>
          <div className="col-12">
            <label className="form-label" style={{ marginBottom: 0 }}>
              Title
            </label>
            <div className="input-group">
              <input
                value={projectData.title}
                onChange={(e) =>
                  setProjectData((prevData) => ({
                    ...prevData,
                    title: e.target.value,
                  }))
                }
                name="dzName"
                required=""
                type="text"
                className="form-control"
                placeholder="Project Title"
              />
            </div>
          </div>
          <div className="col-12">
            <label className="form-label" style={{ marginBottom: 0 }}>
              Description
            </label>
            <div className="input-group">
              <textarea
                value={projectData.description}
                onChange={(e) =>
                  setProjectData((prevData) => ({
                    ...prevData,
                    description: e.target.value,
                  }))
                }
                rows={3}
                name="dzName"
                required=""
                type="text"
                className="form-control"
                placeholder="Project Description"
              />
            </div>
          </div>
          <div className="col-12">
            <label className="form-label" style={{ marginBottom: 0 }}>
              Category
            </label>
            <div className="input-group">
              <input
                value={projectData.category}
                onChange={(e) =>
                  setProjectData((prevData) => ({
                    ...prevData,
                    category: e.target.value,
                  }))
                }
                name="dzName"
                required=""
                type="text"
                className="form-control"
                placeholder="Project Category"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FirstStep;
